export default __webpack_public_path__ + "static/media/Scissor.1248207a.png";